module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "C183"
  }, [_c('strong', [_c('a', {
    attrs: {
      "id": "page_ix"
    }
  }, [_vm._v("Illustrations")])])]), _c('a', {
    attrs: {
      "id": "page_ix"
    }
  }, [_c('p', {
    staticClass: "C203"
  }, [_vm._v("FIGURES")])]), _c('p', {
    staticClass: "C186"
  }, [_c('a', {
    attrs: {
      "id": "page_ix"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/09_Chapter#id_805",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("FIGURE 3.1. Turnout in national, state, and city elections, New York City, 1859–76")])]), _vm._v(" "), _c('p', {
    staticClass: "C186"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/09_Chapter#page_55",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("FIGURE 3.2. Voter turnout and vote share for Democrats in New York City elections, 1860s")])]), _vm._v(" "), _c('p', {
    staticClass: "C186"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/10_Chapter#id_806",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("FIGURE 4.1. Election timing bills by state, 2001–11")])]), _vm._v(" "), _c('p', {
    staticClass: "C186"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/10_Chapter#id_807",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("FIGURE 4.2. Types of elections affected by consolidation proposals")])]), _vm._v(" "), _c('p', {
    staticClass: "C186"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/10_Chapter#page_112",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("FIGURE 4.3. States with school board election consolidation bills, 2001–11")])]), _vm._v(" "), _c('p', {
    staticClass: "C186"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/10_Chapter#id_808",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("FIGURE 4.4. Sponsorship of bills proposing school board election consolidation")])]), _vm._v(" "), _c('p', {
    staticClass: "C186"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/10_Chapter#page_115",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("FIGURE 4.5. Proportion voting for on-cycle school board elections")])]), _vm._v(" "), _c('p', {
    staticClass: "C186"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/10_Chapter#page_117",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("FIGURE 4.6. Proportion voting for on-cycle school board elections, clearest cases")])]), _vm._v(" "), _c('p', {
    staticClass: "C186"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/10_Chapter#id_809",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("FIGURE 4.7. Sponsorship of consolidation bills, excluding state and school board bills")])]), _vm._v(" "), _c('p', {
    staticClass: "C186"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/11_Chapter#id_810",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("FIGURE 5.1. Voter turnout in Minnesota school board elections")])]), _vm._v(" "), _c('p', {
    staticClass: "C186"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/11_Chapter#id_811",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("FIGURE 5.2. Marginal effect of a five-percentage-point decrease in turnout")])]), _vm._v(" "), _c('p', {
    staticClass: "C186"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/11_Chapter#id_812",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("FIGURE 5.3. Treatment and control school districts, House Bill 1")])]), _vm._v(" "), _c('p', {
    staticClass: "C186"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/11_Chapter#id_813",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("FIGURE 5.4. Pretreatment attributes of treatment and control districts")])]), _vm._v(" "), _c('p', {
    staticClass: "C186"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/12_Chapter#page_174",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("FIGURE 6.1. California municipal election timing by county, 2008")])]), _vm._v(" "), _c('p', {
    staticClass: "C186"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/12_Chapter#id_814",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("FIGURE 6.2. Firefighter and police officer compensation by city election timing")])]), _vm._v(" "), _c('p', {
    staticClass: "C203"
  }, [_c('a', {
    attrs: {
      "id": "page_x"
    }
  }, [_vm._v("TABLES")])]), _c('a', {
    attrs: {
      "id": "page_x"
    }
  }), _c('p', {
    staticClass: "C186"
  }, [_c('a', {
    attrs: {
      "id": "page_x"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/07_Chapter#page_8"
    }
  }, [_vm._v("TABLE 1.1. A snapshot of state and local election timing in the United States")])]), _vm._v(" "), _c('p', {
    staticClass: "C186"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/08_Chapter#page_30"
    }
  }, [_vm._v("TABLE 2.1. Election timing and vote shares of competing groups")])]), _vm._v(" "), _c('p', {
    staticClass: "C186"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/09_Chapter#id_815",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("TABLE 3.1. Votes cast in San Francisco during on-cycle and off-cycle")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/xhtml/09_Chapter#id_815",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("elections, 1856–69")])]), _vm._v(" "), _c('p', {
    staticClass: "C186"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/09_Chapter#page_75",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("TABLE 3.2. Municipal election timing in 1940 and 1986, by state")])]), _vm._v(" "), _c('p', {
    staticClass: "C186"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/10_Chapter#id_816",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("TABLE 4.1. Citizens’ election timing preferences by party and ideology")])]), _vm._v(" "), _c('p', {
    staticClass: "C186"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/10_Chapter#id_817",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("TABLE 4.2. Legislative progress of election consolidation bills")])]), _vm._v(" "), _c('p', {
    staticClass: "C186"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/10_Chapter#id_818",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("TABLE 4.3. State partisanship and the legislative progress of nonschool election consolidation bills")])]), _vm._v(" "), _c('p', {
    staticClass: "C186"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/11_Chapter#id_819",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("TABLE 5.1. The Eight-State Test of the effect of election timing")])]), _vm._v(" "), _c('p', {
    staticClass: "C186"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/11_Chapter#page_138",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("TABLE 5.2. The Eight-State Test and partisanship, union strength, and competition")])]), _vm._v(" "), _c('p', {
    staticClass: "C186"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/11_Chapter#id_820",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("TABLE 5.3. The Minnesota Test of the effect of election timing and turnout")])]), _vm._v(" "), _c('p', {
    staticClass: "C186"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/11_Chapter#id_821",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("TABLE 5.4. The Texas Test of the effect of election timing on turnout")])]), _vm._v(" "), _c('p', {
    staticClass: "C186"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/11_Chapter#page_157",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("TABLE 5.5. The Texas Test of the effect of on-cycle elections, matching")])]), _vm._v(" "), _c('p', {
    staticClass: "C186"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/11_Chapter#page_161",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("TABLE 5.6. The Texas Test, district fixed effects regression")])]), _vm._v(" "), _c('p', {
    staticClass: "C186"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/12_Chapter#page_178",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("TABLE 6.1. Voter turnout and election timing in city council elections")])]), _vm._v(" "), _c('p', {
    staticClass: "C186"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/12_Chapter#id_822",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("TABLE 6.2. City election timing and firefighter compensation, basic model")])]), _vm._v(" "), _c('p', {
    staticClass: "C186"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/12_Chapter#id_823",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("TABLE 6.3. City election timing and firefighter compensation, with controls")])]), _vm._v(" "), _c('p', {
    staticClass: "C186"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/12_Chapter#page_193",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("TABLE 6.4. City election timing and police officer compensation")])]), _vm._v(" "), _c('p', {
    staticClass: "C186"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/12_Chapter#page_196",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("TABLE 6.5. Election timing and city finance")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9d6984a0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/05_List_of.vue
// module id = 69
// module chunks = 0